import React from "react";
import ModalWrapper from "components/common/ModalWrapper";
import DetectorMetricChart from "./DetectorMetricChart";
import {
  useAnatomyFilter,
  useAnatomyData,
  useAnatomyUI,
} from "./context/AnatomyContexts";

class DetectorMetricModalInner extends React.PureComponent {
  constructor(props) {
    super(props);

    const { detectorChartProps } = props;
    const { point, data } = detectorChartProps;

    this.state = {
      datetime: point.datetime,
      groupType: point.groupType,
      layerNum: point.layerNum,
      metric: point.metric,
      data,
    };
  }

  render() {
    const {
      isOpenViewModal,
      handleClose,
      unitInfo,
      getFilterParams,
      timezoneType,
    } = this.props;
    const { groupType, layerNum, metric, data, datetime } = this.state;

    return (
      <ModalWrapper
        isOpen={isOpenViewModal}
        showCloseFooter={true}
        handleClose={handleClose}
        title="Detector Prices by Metric"
      >
        <div className="overflow-y-auto" style={{ maxHeight: "600px" }}>
          <DetectorMetricChart
            unitInfo={unitInfo}
            data={data}
            getFilterParams={getFilterParams}
            groupType={groupType}
            layerNum={layerNum}
            metric={metric}
            datetime={datetime}
            timezoneType={timezoneType}
          ></DetectorMetricChart>
        </div>
      </ModalWrapper>
    );
  }
}

const DetectorMetricModal = React.memo((props) => {
  const filterContext = useAnatomyFilter();
  const dataContext = useAnatomyData();
  const uiContext = useAnatomyUI();

  if (!filterContext || !dataContext || !uiContext) {
    return <DetectorMetricModalInner {...props} />;
  }

  return (
    <DetectorMetricModalInner
      {...props}
      isOpenViewModal={uiContext.isDetectorModalOpen}
      timezoneType={filterContext.timezoneType}
      handleClose={uiContext.handleCloseModal}
      detectorChartProps={uiContext.detectorChartProps}
      unitInfo={dataContext.unitInfo}
      getFilterParams={filterContext.getFilterParams}
    />
  );
});

export default DetectorMetricModal;
